<template>
  <section class="vbox">
    <section class="scrollable padder">
      <section class="row m-b-md brud-theme">
        <div class="col-sm-6 text-black">
          <ol class="breadcrumb text-left">
            <li>
              <a href="#"><i class="fa fa-dashboard"></i> Home</a>
            </li>
            <li class="active">List of Sale</li>
          </ol>
        </div>
        <div class="col-sm-6 text-right text-left m-t-sm">
          <small> </small>
        </div>
      </section>

      <section class="panel panel-default">
        <header class="panel-heading">
          <div class="row">
            <div class="col-sm-12">
              <a
                v-on:click="showForm(0)"
                class="btn btn-success pull-right"
              >
                <i class="fa fa-plus"> </i> New Sale
              </a>
              <h4>
                <i class="fa fa-list-ul"></i>
                Search Sale
              </h4>
            </div>
          </div>
        </header>
        <div class="modal-body">
          <form @submit.prevent="getList()" method="post">
            <div class="row">
              <div class="col-lg-4">
                <div class="form-group" style="padding-top: 25px;">
                  <button type="submit" class="btn btn-success">
                    &nbsp;&nbsp;&nbsp; Search &nbsp;&nbsp;&nbsp;
                  </button>
                  <!-- <a href="" class="btn btn-danger"
                    >&nbsp;&nbsp;&nbsp;&nbsp; Reset &nbsp;&nbsp;&nbsp;&nbsp;</a
                  > -->
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
      <panel-modal
        v-if="showFormModal"
        class-list="col-md-6"
        @close="showFormModal = false"
      >
        <template #header>
          <h4>
            <i class="fa fa-list-ul"></i>
            Add / Edit Sale
          </h4>
        </template>
        <template #body>
          <AddSale
            :saleId="itemId"
            v-on:list-items="getList()"
            v-on:hide-form="showFormModal = false"
          />
        </template>
      </panel-modal>
      <panel-modal
        v-if="showCartModal"
        class-list="col-md-6"
        @close="showCartModal = false"
      >
        <template #header>
          <h6>
            <i class="fa fa-list-ul"></i>
           Sale Items
          </h6>          
        </template>
        <template #body>
          <table
              class="table table-striped table-bordered table-hover"
            >
              <thead>
                <tr>
                  <th width="5%">#</th>
                  <th width="10%">Product</th>
                  <th width="10%">Quantity</th>
                  <th width="10%">Price</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in productList"
                  :key="item.sale_item_id"
                >
                  <td id="sino"></td>
                  <td>
                    {{ item.product_name }}</td>
                  <td>
                    {{ item.quantity }}</td>
                  <td>
                    {{ item.unit_price }}</td>
                </tr>
              </tbody>
            </table>
        </template>
      </panel-modal>
      <section class="content">
        <div class="row">
          <div class="col-md-12">
            <div class="box">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <i class="fa fa-list-ul"></i>
                  SALE LIST
                </div>
                <div style="overflow-x:auto;" class="panel-body">
                  <table
                    class="table table-striped table-bordered table-hover"
                  >
                    <thead>
                      <tr>
                        <th width="5%">#</th>
                        <th width="10%">Sale Date</th>
                        <th width="10%">Customer Name</th>
                        <th width="10%">Invoice Number</th>
                        <th width="10%">Invoice Amount</th>
                        <th width="10%">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in itemList"
                        :key="item.sale_id"
                      >
                        <td id="sino"></td>
                        <td>
                          {{ dateFormat(item.sale_date) }}</td>
                        <td>
                          {{ item.customer_name }}</td>
                        <td>
                          {{ item.invoice_number }}</td>
                        <td>
                          {{ item.invoice_amount }}</td>
                        <td>
                          <a class="btn label-info btn-xs" v-on:click="showCart()"
                          style="float: left;display: block; width: 100%;margin-bottom:3px;">
                            <i class="fa fa-eye"></i> View Items</a>
                          <a
                            v-on:click="showForm(item.sale_id)"
                            class="btn label-warning btn-xs"
                            style="float: left;display: block; width: 100%;"
                            ><i class="fa fa-edit"></i> Edit</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- Show pagination links -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  </section>
</template>

<script>

import api from "../api";
import AddSale from "../components/AddSale.vue";
import PanelModal from "../components/PanelModal.vue";

export default {
  name: "Sale",

  components: {
    AddSale,
    PanelModal,
  },
  data() {
    return {
      showFormModal: false,
      showCartModal: false,
      itemList: [],
      itemId: "",
      StatusActive: true,
      productList: []
    };
  },
  methods: {
    dateFormat: function(date) {
      var options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      var formatdate = new Date(date);
      var dateformat = formatdate.toLocaleDateString("en-US", options);
      return dateformat;
    },
    getList: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_sales", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.itemList = response.data.values;
          } else {
            this.itemList = data.saleList;
          }
        });
    },
    getCartList: function(id) {
      const list = {
        filter: {
          sale_id: id
        },
      };
      api
        .request("post", "GeneralApis/get_sale_items", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.productList = response.data.values;
          } else {
            this.productList = data.cartList;
          }
        });
    },
    showForm: function(saleid) {
      this.itemId = saleid;
      this.showFormModal = true;
    },
    showCart: function(saleid) {
      this.getCartList(saleid)
      this.showCartModal = true;
    }
  },
  mounted(){
    this.getList()
  }
};
</script>
